// extracted by mini-css-extract-plugin
export var parent = "menu-module--parent--D+ufw";